<form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-8">
  <div class="flex gap-8 max-md:flex-col md:gap-4">
    <!-- Salutation -->
    <p-floatlabel variant="on" class="w-full md:w-32">
      <p-select
        inputId="salutation"
        formControlName="salutation"
        [options]="salutationOptions"
        optionLabel="label"
        optionValue="value"
        size="large"
        class="w-full !bg-zinc-50" />
      <label for="salutation" class="!bg-zinc-50">{{ 'profile.form.label.salutation' | transloco }}</label>
    </p-floatlabel>

    <!-- Firstname -->
    <div class="flex flex-1 flex-col gap-1">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          pSize="large"
          id="firstName"
          formControlName="firstName"
          [placeholder]="'profile.form.placeholder.firstName' | transloco"
          class="w-full !bg-zinc-50"
          data-testid="profile-firstName-input" />
        <label for="firstName" class="!bg-zinc-50">{{ 'user.firstName' | transloco }}</label>
      </p-floatlabel>
      @if (hasError('firstName', 'required')) {
        <small class="text-red-500">{{ 'profile.form.error.required' | transloco }}</small>
      }
      @if (hasError('firstName', 'minlength')) {
        <small class="text-red-500">{{ 'profile.form.error.minLength' | transloco: { minLength: 5 } }}</small>
      }
    </div>

    <!-- Lastname -->
    <div class="flex flex-1 flex-col gap-1">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          pSize="large"
          id="lastName"
          formControlName="lastName"
          [placeholder]="'profile.form.placeholder.lastName' | transloco"
          class="w-full !bg-zinc-50"
          data-testid="profile-lastName-input" />
        <label for="lastName" class="!bg-zinc-50">{{ 'user.lastName' | transloco }}</label>
      </p-floatlabel>
      @if (hasError('lastName', 'required')) {
        <small class="text-red-500">{{ 'profile.form.error.required' | transloco }}</small>
      }
      @if (hasError('lastName', 'minlength')) {
        <small class="text-red-500">{{ 'profile.form.error.minLength' | transloco: { minLength: 5 } }}</small>
      }
    </div>
  </div>

  <!-- Phone Number -->
  <div class="flex flex-col gap-1">
    <p-floatlabel variant="on" class="w-full">
      <input
        pInputText
        pSize="large"
        id="phoneNumber"
        formControlName="phoneNumber"
        [placeholder]="'profile.form.placeholder.phoneNumber' | transloco"
        class="w-full !bg-zinc-50" />
      <label for="phoneNumber" class="!bg-zinc-50">{{ 'user.phoneNumber' | transloco }}</label>
    </p-floatlabel>
  </div>

  <!-- E-Mail -->
  <div class="flex flex-col gap-1">
    <p-floatlabel variant="on" class="w-full">
      <input
        pInputText
        pSize="large"
        id="email"
        formControlName="email"
        [placeholder]="'profile.form.placeholder.email' | transloco"
        class="w-full !bg-zinc-50" />
      <label for="email" class="!bg-zinc-50">{{ 'user.email' | transloco }}</label>
    </p-floatlabel>
    <small class="leading-tight text-stone-600">{{ 'profile.form.hint.mailNonChange' | transloco }}</small>
  </div>

  <!-- Password -->
  <div class="flex flex-col gap-1">
    <p-floatlabel variant="on" class="w-full">
      <input pInputText pSize="large" id="password" formControlName="password" type="password" class="w-full !bg-zinc-50" />
      <label for="password" class="!bg-zinc-50">{{ 'user.password' | transloco }}</label>
    </p-floatlabel>
    <small class="leading-tight text-stone-600">{{ 'profile.form.hint.password' | transloco }}</small>
  </div>

  <!-- Companyname -->
  <div class="flex flex-col gap-1">
    <p-floatlabel variant="on" class="w-full">
      <input
        pInputText
        pSize="large"
        id="companyName"
        formControlName="companyName"
        [placeholder]="'profile.form.placeholder.companyName' | transloco"
        class="w-full !bg-zinc-50"
        data-testid="profile-companyName-input" />
      <label for="companyName" class="!bg-zinc-50">{{ 'user.companyName' | transloco }}</label>
    </p-floatlabel>
    @if (hasError('companyName', 'required')) {
      <small class="text-red-500">{{ 'profile.form.error.required' | transloco }}</small>
    }
  </div>

  <!-- Street plus Number -->
  <div class="flex flex-col gap-1">
    <p-floatlabel variant="on" class="w-full">
      <input
        pInputText
        pSize="large"
        id="streetPlusNumber"
        formControlName="streetPlusNumber"
        [placeholder]="'profile.form.placeholder.streetPlusNumber' | transloco"
        class="w-full !bg-zinc-50" />
      <label for="streetPlusNumber" class="!bg-zinc-50">{{ 'user.streetPlusNumber' | transloco }}</label>
    </p-floatlabel>
    @if (hasError('streetPlusNumber', 'required')) {
      <small class="text-red-500">{{ 'profile.form.error.required' | transloco }}</small>
    }
  </div>

  <!-- Extra Address Entry -->
  <div class="flex flex-col gap-1">
    <p-floatlabel variant="on" class="w-full">
      <input
        pInputText
        pSize="large"
        id="extraAdressEntry"
        formControlName="extraAdressEntry"
        [placeholder]="'profile.form.placeholder.extraAdressEntry' | transloco"
        class="w-full !bg-zinc-50" />
      <label for="extraAdressEntry" class="!bg-zinc-50">{{ 'user.extraAdressEntry' | transloco }}</label>
    </p-floatlabel>
  </div>

  <div class="flex gap-4">
    <!-- Zip -->
    <div class="flex w-1/3 flex-col gap-1 md:w-1/4">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          pSize="large"
          id="zip"
          formControlName="zip"
          [placeholder]="'profile.form.placeholder.zip' | transloco"
          class="w-full !bg-zinc-50"
          data-testid="profile-zip-input" />
        <label for="zip" class="!bg-zinc-50">{{ 'user.zip' | transloco }}</label>
      </p-floatlabel>
      @if (hasError('zip', 'required')) {
        <small class="text-red-500">{{ 'profile.form.error.required' | transloco }}</small>
      }
    </div>

    <!-- City -->
    <div class="flex w-2/3 flex-col gap-1 md:w-3/4">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          pSize="large"
          id="city"
          formControlName="city"
          [placeholder]="'profile.form.placeholder.city' | transloco"
          class="w-full !bg-zinc-50" />
        <label for="city" class="!bg-zinc-50">{{ 'user.city' | transloco }}</label>
      </p-floatlabel>
      @if (hasError('city', 'required')) {
        <small class="text-red-500">{{ 'profile.form.error.required' | transloco }}</small>
      }
    </div>
  </div>

  <!-- Country -->
  <div class="flex flex-col gap-1">
    <p-floatlabel variant="on" class="w-full">
      <input
        pInputText
        pSize="large"
        id="country"
        formControlName="country"
        [placeholder]="'profile.form.placeholder.country' | transloco"
        class="w-full !bg-zinc-50" />
      <label for="country" class="!bg-zinc-50">{{ 'user.country' | transloco }}</label>
    </p-floatlabel>
    <small class="leading-tight text-stone-600">{{ 'profile.form.hint.countryNonChange' | transloco }}</small>
  </div>

  <div class="flex flex-wrap gap-8 md:gap-4">
    <!-- Vat Number -->
    <p-floatlabel variant="on" class="w-full md:flex-1">
      <input
        pInputText
        pSize="large"
        id="vatNumber"
        formControlName="vatNumber"
        [placeholder]="'profile.form.placeholder.vatNumber' | transloco"
        class="w-full !bg-zinc-50" />
      <label for="vatNumber" class="!bg-zinc-50">{{ 'user.vatNumber' | transloco }}</label>
    </p-floatlabel>

    <!-- Number of Employees -->
    <div class="flex w-full flex-col gap-1 md:w-48">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          pSize="large"
          id="numOfEmployees"
          formControlName="numOfEmployees"
          [placeholder]="'profile.form.placeholder.numOfEmployees' | transloco"
          class="w-full !bg-zinc-50"
          data-testid="profile-employeesNumber-input" />
        <label for="numOfEmployees" class="!bg-zinc-50">{{ 'user.numOfEmployees' | transloco }}</label>
      </p-floatlabel>
      @if (hasError('numOfEmployees', 'required')) {
        <small class="text-red-500">{{ 'profile.form.error.required' | transloco }}</small>
      }
    </div>

    <!-- Number of Platforms -->
    <div class="flex w-full flex-col gap-1 md:w-48">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          pSize="large"
          id="numOfPlatforms"
          formControlName="numOfPlatforms"
          [placeholder]="'profile.form.placeholder.numOfPlatforms' | transloco"
          class="w-full !bg-zinc-50"
          data-testid="profile-platformsNumber-input" />
        <label for="numOfPlatforms" class="!bg-zinc-50">{{ 'user.numOfPlatforms' | transloco }}</label>
      </p-floatlabel>
      @if (hasError('numOfPlatforms', 'required')) {
        <small class="text-red-500">{{ 'profile.form.error.required' | transloco }}</small>
      }
    </div>
  </div>

  <!-- Partner Code -->
  <div class="flex flex-col gap-1">
    <p-floatlabel variant="on" class="w-full">
      <input
        pInputText
        pSize="large"
        id="partnerCode"
        formControlName="partnerCode"
        [placeholder]="'profile.form.placeholder.partnerCode' | transloco"
        class="w-full !bg-zinc-50" />
      <label for="partnerCode" class="!bg-zinc-50">{{ 'user.partnerCode.name' | transloco }}</label>
    </p-floatlabel>
    <small class="leading-tight text-stone-600">{{ 'profile.form.hint.partnerCode' | transloco }}</small>
  </div>

  <div class="mt-8 flex justify-end gap-4">
    <p-button severity="contrast" [label]="'global.cancel' | transloco" type="button" [outlined]="true" (onClick)="onCancelClick()" />
    <p-button severity="contrast" [label]="'profile.form.save' | transloco" type="submit" />
  </div>
</form>
